<template>
    <div class="panel panel-clinic">

        <div class="panel-heading collapsed" href="#product_affiliates_api_map" data-toggle="collapse">
            <div class="arrow-down"></div>
            <h2 class="panel-title">API kopplingar</h2>
        </div>

        <div id="product_affiliates_api_map" class="panel-collapse collapse">

            <div class="panel-body">

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <div class="row">
                            <div class="col-md-12">Källa</div>
                            <div class="col-md-12">Försäljningskanal</div>
                            <div class="col-md-12">API nyckel</div>
                            <div class="col-md-12"></div>
                        </div>
                    </div>
                </div>

                <div class="list-group">
                    <row-new :product="product" :affiliates="filteredAffiliates" @refresh="fetcherFetch" />
                    <row :product="product" :key="'m_'+map.id" :map="map" v-for="map in apiMap" @refresh="fetcherFetch" />
                </div>

            </div>

        </div>

    </div>
</template>

<script>

import fetcher from '../../shared/mixins/fetcher'

import rowNew from './product.affiliate.api.map.row-new.vue'
import row from './product.affiliate.api.map.row.vue'
export default {

    mixins: [
        fetcher
    ],

    components: {
        rowNew,
        row
    },

    props: {
        product: {}
    },

    data () {
        return {
            affiliates: [],
            apiMap: [],

            fetcher: {
                autoFill: [
                    'affiliates',
                    'apiMap'
                ]
            }
        }
    },

    computed: {

        fetcherUrl () {
            return '/products/' + this.product.id + '/apiMap'
        },

        filteredAffiliates () {
            let affiliates = this.affiliates

            if (this.showOnlyActive) {
                affiliates = affiliates.filter((affiliate) => {
                    return affiliate.is_active == true
                })
            }

            return _.orderBy(affiliates, ['name'], ['asc'])
        }

    },

    methods: {

    }

}
</script>
